import { Extension } from "@tiptap/core";
import { Plugin, PluginKey } from "@tiptap/pm/state";
import type { EditorView } from "@tiptap/pm/view";

import type { SuggestionState } from "./suggestion-types";
import { getSuggestionState } from "./suggestion-utils";

export interface SuggestionPluginOptions {
  onUpdate?: (state: SuggestionState | null, view: EditorView) => void;
  onKeyDown?: (view: EditorView, event: KeyboardEvent) => boolean;
  getContainerRect?: () => DOMRect | null;
}

/**
 * This extension provides suggestion functionality for resource tokens in the editor.
 * TODO: expand suggestion functionality for different types of resources!
 */
export const ResourceSuggestionPlugin = Extension.create<SuggestionPluginOptions>({
	name: "resource-suggestion",
	addOptions() {
		return {
			onUpdate: undefined,
			onKeyDown: undefined,
			getContainerRect: undefined,
		} satisfies SuggestionPluginOptions;
	},
	addProseMirrorPlugins() {
		// whenever document changes, call getSuggestionState with editor state etc - result is passed to onUpdate which updates suggestionState in the UI
		return [
			new Plugin({
				key: new PluginKey("resource-suggestion"),
				view: (editorView) => {
					return {
						update: (view) => {
							const containerRect = this.options.getContainerRect?.() ?? null;

							const suggestion = getSuggestionState(view.state, {
								containerRect,
								getCoordsAtPos: (pos) => view.coordsAtPos(pos),
							});

							this.options.onUpdate?.(suggestion, view);
						},
					};
				},
				props: {
					handleKeyDown: (view, event) => {
						return this.options.onKeyDown?.(view, event) ?? false;
					},
				},
			}),
		];
	},
});
